import {WaitingStatus} from '@web/core/constants'
import makeSlice from '@web/slices/waiting/sliceMaker'

import {initOrderSheetByAPI} from '../../actions'

const waitingSlice = makeSlice({
    extraReducers(builder) {
        builder.addCase(initOrderSheetByAPI.rejected, (state, {payload}) => {
            if (payload?.status === 403) {
                state.status = WaitingStatus.INITIALIZED
            }
        })
    },
})

export default waitingSlice.reducer
export const actions = waitingSlice.actions
